module.exports = __webpack_public_path__ + "media/images/sms-messaging-off-fbf0f3b693765166f31359621db6ee79.png";